import { render, staticRenderFns } from "./LabelContractsCostsEditPanel.vue?vue&type=template&id=a8c2d20e"
import script from "./LabelContractsCostsEditPanel.vue?vue&type=script&lang=js"
export * from "./LabelContractsCostsEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports